module.exports = __webpack_public_path__ + "static/media/mobileBg.d39675f0.jpg";